import React from 'react';
import { st, classes } from './dropdown-button.st.css';
const DropdownButton = ({ className, disabled = false, buttonProps: { children: buttonChildren, className: buttonClassname, ...buttonProps }, initialState = false, onShowCallback, buttonComponent, children: renderChildren, }) => {
    const [state, setState] = React.useState({
        isVisible: initialState,
        isKbTriggered: false,
    });
    const buttonRef = React.useRef(null);
    React.useEffect(() => {
        if (state.isVisible) {
            document.addEventListener('click', handleDocumentClick);
            document.addEventListener('keyup', handleDocumentKeyUp);
        }
        return () => {
            document.removeEventListener('click', handleDocumentClick);
            document.removeEventListener('keyup', handleDocumentKeyUp);
        };
    }, [state.isVisible]);
    React.useEffect(() => {
        if (state.isVisible) {
            onShowCallback?.();
        }
    }, [state.isVisible, onShowCallback]);
    const hideDropdown = React.useMemo(() => ({ returnFocus }) => {
        returnFocus && buttonRef.current?.focus();
        setState({ isKbTriggered: false, isVisible: false });
    }, []);
    const handleDocumentClick = (e) => {
        if (buttonRef.current?.contains(e.target)) {
            return;
        }
        hideDropdown({ returnFocus: false });
    };
    const handleDocumentKeyUp = (e) => {
        if (e.key === 'Escape' || e.key === 'Tab') {
            hideDropdown({ returnFocus: e.key === 'Escape' });
        }
    };
    const Component = buttonComponent ? buttonComponent : 'button';
    const children = typeof renderChildren === 'function'
        ? renderChildren({
            isKbTriggered: state.isKbTriggered,
            closeDropdown: () => {
                hideDropdown({ returnFocus: true });
            },
        })
        : renderChildren;
    return (React.createElement("div", { className: className },
        React.createElement("div", { ref: buttonRef },
            React.createElement(Component, { className: st(classes.button, buttonClassname), ...buttonProps, onClick: () => {
                    if (disabled || state.isVisible) {
                        return;
                    }
                    setState({ isKbTriggered: false, isVisible: true });
                }, onKeyDown: (e) => {
                    if (disabled || state.isVisible) {
                        return;
                    }
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setState({ isKbTriggered: true, isVisible: true });
                    }
                }, "aria-haspopup": "true", "aria-expanded": state.isVisible }, buttonChildren ? buttonChildren : null)),
        state.isVisible ? children : null));
};
export default DropdownButton;
//# sourceMappingURL=dropdown-button.js.map